import React from 'react'
import './display.css'

const Display = () => {
  return (
    <div className="display_kr">
        <div className="disp_img">
        <img src="https://largo.studio/assets/cms/2022/12/221004_013.jpg"/>
        </div>
        <div className="disp_img_sec">
        <div className="disp_img_sub1"><img src="https://s3-us-west-2.amazonaws.com/handel-architects/images/_large/01.070.12.021.jpg"/></div>
        <div className="disp_img_sub2"><img src="https://s3-us-west-2.amazonaws.com/handel-architects/images/_large/01.070.12.016.jpg" /></div>
            </div>
        <div className="disp_img">
        <img src="https://largo.studio/assets/cms/2022/12/221004_018.jpg"/>
            </div>
            <div className="disp_img">
            <img src="https://largo.studio/assets/cms/2022/12/221004_011.jpg"/>
            </div>
   
     
    </div>
  )
}

export default Display